import React, { createContext, useContext, useState, useEffect } from "react"
import { translations } from "../translations/homepage"

const LanguageContext = createContext()

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState("en")

  useEffect(() => {
    const saved = typeof window !== "undefined" && window.localStorage.getItem("lang")
    if (saved) setLanguage(saved)
  }, [])

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("lang", language)
      document.documentElement.dir = language === "ar" ? "rtl" : "ltr"
      document.documentElement.lang = language
    }
  }, [language])

  const t = (key) => {
    return translations[key]?.[language] ?? translations[key]?.en ?? key
  }

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  return useContext(LanguageContext)
}